/*
  Oferta de pachete după adăugarea unei frecvențe în coș.

  Nu atinge deloc fluxul lui Dawn. Ascultă evenimentul „cartUpdate" pe care
  tema îl publică oricum, iar dacă produsul adăugat e o frecvență, închide
  sertarul de coș și arată oferta peste el. Dacă omul refuză, sertarul se
  redeschide și totul e ca înainte.

  Pachetele nu sunt produse. Omul alege N frecvențe, ele intră normal în coș,
  iar reducerea automată din admin scade prețul. Așa fiecare frecvență își
  păstrează fișierul din Digital Downloads și livrarea merge singură.
*/
(function () {
  'use strict';

  var radacina = document.getElementById('hf-up');
  if (!radacina) return;
  /* Prețuri America, stabilite 6 septembrie 2026, în cenți.
     55 $ bucata · 2 la 77 $ · 3 la 99 $.

     ⚠️ Trebuie să corespundă reducerilor automate din admin:
        2 frecvențe → 33 $ reducere   (2 × 55 − 77)
        3 frecvențe → 66 $ reducere   (3 × 55 − 99)
     Sumă fixă, nu procent. Dacă schimbi una, schimbă-le pe amândouă.

     Ordinea din listă e ordinea de pe ecran. Cardul cu etichetă vine al
     doilea, ca privirea să ajungă la el după ce a văzut cu ce se compară. */
  var PACHETE = [
    { n: 2, pret: 7700, eticheta: null },
    { n: 3, pret: 9900, eticheta: 'Best value' },
  ];

  var CEL_MAI_MARE = PACHETE.reduce(function (m, p) { return p.n > m ? p.n : m; }, 0);

  var POZE = {};
  try {
    POZE = JSON.parse(radacina.dataset.poze || '{}');
  } catch (e) { /* fără imagini, se folosește teancul de coperte */ }

  var produse = [];
  try {
    produse = JSON.parse(radacina.dataset.produse || '[]');
  } catch (e) {
    return;
  }
  /* Fără destule frecvențe disponibile, cel mai mare pachet n-ar putea fi
     completat și oferta ar fi o promisiune pe care n-o putem ține. */
  if (produse.length < CEL_MAI_MARE) return;

  var pretUnitar = parseInt(radacina.dataset.pretUnitar, 10) || produse[0].pret;
  var idFrecvente = produse.map(function (p) { return p.id; });

  var elCarduri = radacina.querySelector('[data-hf-up-carduri]');
  var elGrila = radacina.querySelector('[data-hf-up-grila]');
  var elContor = radacina.querySelector('[data-hf-up-contor]');
  var elFinal = radacina.querySelector('[data-hf-up-final]');
  var elTitluAlegere = radacina.querySelector('[data-hf-up-titlu-alegere]');
  var elSubAlegere = radacina.querySelector('[data-hf-up-sub-alegere]');
  var elAcord = radacina.querySelector('[data-hf-up-acord]');
  var elAles = radacina.querySelector('[data-hf-up-ales]');

  /* Varianta tocmai pusă în coș, ca s-o putem arăta în casetă. O aflăm din
     evenimentul de adăugare, nu din coș: coșul nu spune care linie e nouă. */
  var ultimaAdaugata = null;

  var pachetActiv = null;
  var alese = [];
  var inCos = [];
  var trimite = false;

  /* ---------- ajutoare ---------- */

  function bani(v) {
    var dolari = v / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: dolari % 1 === 0 ? 0 : 2,
    }).format(dolari);
  }

  function urlPlata() {
    return '/checkout';
  }

  function sertar() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function citesteCos() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        inCos = [];
        (c.items || []).forEach(function (linie) {
          if (idFrecvente.indexOf(linie.id) !== -1) {
            for (var i = 0; i < linie.quantity; i++) inCos.push(linie.id);
          }
        });
        return inCos;
      })
      .catch(function () { return (inCos = []); });
  }

  /* ---------- pasul 1: opțiunile ---------- */

  /* Caseta cu frecvența tocmai adăugată. Rolul ei e să confirme, nu să vândă:
     omul trebuie să vadă în două secunde că a nimerit produsul dorit, altfel
     citește oferta cu o îndoială în spate. */
  function desenAles() {
    if (!elAles) return;

    var p = null;
    for (var k = 0; k < produse.length; k++) {
      if (produse[k].id === ultimaAdaugata) { p = produse[k]; break; }
    }
    if (!p) { elAles.hidden = true; return; }

    elAles.innerHTML = '';

    var poza = document.createElement('img');
    poza.className = 'hf-up__ales-poza';
    poza.src = p.poza;
    poza.alt = '';
    poza.loading = 'lazy';

    var text = document.createElement('span');
    text.className = 'hf-up__ales-text';

    var eticheta = document.createElement('small');
    eticheta.textContent = 'Already in your cart';

    var nume = document.createElement('strong');
    /* textContent, nu innerHTML: titlul vine din catalog, iar un apostrof sau
       un semn mai mic ar rupe marcajul. */
    nume.textContent = p.titlu;

    text.appendChild(eticheta);
    text.appendChild(nume);
    elAles.appendChild(poza);
    elAles.appendChild(text);
    elAles.hidden = false;
  }

  function desenCarduri() {
    elCarduri.innerHTML = '';

    PACHETE.forEach(function (pachet) {
      var buton = document.createElement('button');
      buton.type = 'button';
      buton.className = 'hf-up__treapta' + (pachet.n === CEL_MAI_MARE ? ' hf-up__treapta--top' : '');
      buton.textContent = pachet.n + ' frequencies for ' + bani(pachet.pret);
      buton.addEventListener('click', function () { alegePachet(pachet); });
      elCarduri.appendChild(buton);
    });
  }

  /* ---------- pasul 2: alegerea ---------- */

  function alegePachet(pachet) {
    pachetActiv = pachet;
    alese = inCos.slice(0, pachet.n);
    desenGrila();
    arataPas('alegere');
  }

  function desenGrila() {
    elTitluAlegere.textContent = 'Choose your ' + pachetActiv.n + ' frequencies';

    var deja = inCos.length;
    elSubAlegere.textContent = deja
      ? (deja === 1
          ? 'You already have one frequency in your cart, and it is ticked. Choose ' + (pachetActiv.n - Math.min(deja, pachetActiv.n)) + ' more.'
          : 'You already have ' + deja + ' frequencies in your cart, and they are ticked.')
      : 'Your body already knows what it needs.';

    elGrila.innerHTML = '';
    produse.forEach(function (p) {
      var buton = document.createElement('button');
      buton.type = 'button';
      buton.className = 'hf-up__optiune';
      buton.dataset.id = String(p.id);
      buton.innerHTML =
        '<span class="hf-up__bifa" aria-hidden="true"></span>' +
        '<img src="' + p.poza + '" alt="" loading="lazy">' +
        '<span class="hf-up__optiuneNume">' + p.titlu + '</span>';
      buton.addEventListener('click', function () { comuta(p.id); });
      elGrila.appendChild(buton);
    });

    actualizeaza();
  }

  function comuta(id) {
    var i = alese.indexOf(id);
    if (i !== -1) {
      alese.splice(i, 1);
    } else if (alese.length < pachetActiv.n) {
      alese.push(id);
    } else {
      /* Pachetul e plin: înlocuiește ultima alegere, ca să nu pară că butonul e stricat. */
      alese.pop();
      alese.push(id);
    }
    actualizeaza();
  }

  function actualizeaza() {
    if (!pachetActiv) return;
    var n = pachetActiv.n;
    Array.prototype.forEach.call(elGrila.children, function (b) {
      var ales = alese.indexOf(Number(b.dataset.id)) !== -1;
      b.classList.toggle('is-ales', ales);
      b.setAttribute('aria-pressed', ales ? 'true' : 'false');
    });

    var completat = alese.length === n;
    var acordat = !elAcord || elAcord.checked;

    elContor.textContent = 'You have chosen ' + alese.length + ' of ' + n;
    elContor.classList.toggle('is-gata', completat);
    elFinal.disabled = !(completat && acordat);

    if (!completat) {
      elFinal.textContent = 'Choose ' + (n - alese.length) + ' more';
    } else if (!acordat) {
      elFinal.textContent = 'Tick the box to continue';
    } else {
      elFinal.textContent = 'Go to checkout — ' + bani(pachetActiv.pret);
    }
  }

  if (elAcord) elAcord.addEventListener('change', actualizeaza);

  /* ---------- trimiterea în coș ---------- */

  /* Acordul se salvează pe coș, cu dată și oră, ca să fie vizibil pe comandă.
     Primește bifa de folosit, pentru că sunt două: una la alegerea pachetului
     și una la refuz, iar amândouă duc direct la plată. */
  /* 20 oct. 2026: fără bifă — acordul se scrie mereu, „Yes, by ordering, <data ora>". */
  function salveazaAcordul() {
    var acum = 'Yes, by ordering, ' + new Date().toISOString().replace('T', ' ').slice(0, 19);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Digital delivery consent': acum } }),
    }).catch(function () { /* nu blocăm cumpărarea dacă atributul eșuează */ });
  }

  /* ---------- refuzul ofertei ---------- */

  var elAcordRefuz = radacina.querySelector('[data-hf-up-acord-refuz]');
  var elRefuz = radacina.querySelector('[data-hf-up-refuz]');
  var elRefuzNota = radacina.querySelector('[data-hf-up-refuz-nota]');
  var NOTA_REFUZ = elRefuzNota ? elRefuzNota.textContent : '';

  if (elAcordRefuz) {
    elAcordRefuz.addEventListener('change', function () {
      if (!elAcordRefuz.checked) return;
      var bloc = elAcordRefuz.closest('.hf-up__acord');
      if (bloc) bloc.classList.remove('is-lipsa');
      if (elRefuzNota) elRefuzNota.textContent = NOTA_REFUZ;
    });
  }

  /* Folosită și de butonul de refuz, și de X. Amândouă duc la plată, deci
     amândouă trebuie să treacă prin acord — altfel una dintre ieșiri l-ar
     ocoli, iar comanda s-ar încheia fără el înregistrat. */
  function mergiLaPlata() {
    if (trimite) return;

    if (elAcordRefuz && !elAcordRefuz.checked) {
      var bloc = elAcordRefuz.closest('.hf-up__acord');
      if (bloc) {
        bloc.classList.add('is-lipsa');
        bloc.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      if (elRefuzNota) elRefuzNota.textContent = 'Tick the box so you can continue.';
      elAcordRefuz.focus();
      return;
    }

    trimite = true;
    if (elRefuz) elRefuz.classList.add('is-ocupat');
    salveazaAcordul(elAcordRefuz).then(function () {
      window.location = urlPlata();
    });
  }

  if (elRefuz) elRefuz.addEventListener('click', mergiLaPlata);

  var elX = radacina.querySelector('[data-hf-up-x]');
  if (elX) elX.addEventListener('click', mergiLaPlata);

  elFinal.addEventListener('click', function () {
    if (trimite || alese.length !== pachetActiv.n) return;
    if (elAcord && !elAcord.checked) return;
    trimite = true;
    elFinal.classList.add('is-ocupat');
    elFinal.textContent = 'One moment…';

    /* Ce e deja în coș nu se mai adaugă o dată. */
    var ramase = inCos.slice();
    var deAdaugat = [];
    alese.forEach(function (id) {
      var i = ramase.indexOf(id);
      if (i !== -1) ramase.splice(i, 1);
      else deAdaugat.push({ id: id, quantity: 1 });
    });

    var adaugarea = deAdaugat.length
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: deAdaugat }),
        }).then(function (r) { return r.json(); })
      : Promise.resolve();

    adaugarea
      .then(function () { return salveazaAcordul(elAcord); })
      .then(function () {
        /* Direct la plată. Reducerea se vede și acolo, în sumar. */
        window.location = urlPlata();
      })
      .catch(function () {
        trimite = false;
        elFinal.classList.remove('is-ocupat');
        elFinal.textContent = 'Try again';
      });
  });

  /* ---------- deschidere / închidere ---------- */

  function arataPas(nume) {
    Array.prototype.forEach.call(radacina.querySelectorAll('[data-hf-up-pas]'), function (pas) {
      pas.hidden = pas.dataset.hfUpPas !== nume;
    });
    radacina.querySelector('.hf-up__panou').scrollTop = 0;
  }

  function deschide() {
    var s = sertar();
    if (s && typeof s.close === 'function') {
      try { s.close(); } catch (e) { /* sertarul poate lipsi pe unele pagini */ }
    }

    desenAles();
    desenCarduri();
    arataPas('oferta');
    radacina.hidden = false;
    document.body.classList.add('hf-up-deschis');
    requestAnimationFrame(function () {
      radacina.classList.add('is-vizibil');
      var x = radacina.querySelector('.hf-up__x');
      if (x) x.focus();
    });
  }

  function inchide() {
    radacina.classList.remove('is-vizibil');
    document.body.classList.remove('hf-up-deschis');
    setTimeout(function () { radacina.hidden = true; }, 250);
    try { sessionStorage.setItem('hf-up-refuzat', '1'); } catch (e) { /* mod privat */ }
  }

  Array.prototype.forEach.call(radacina.querySelectorAll('[data-hf-up-inchide]'), function (b) {
    b.addEventListener('click', inchide);
  });
  radacina.querySelector('[data-hf-up-inapoi]').addEventListener('click', function () {
    arataPas('oferta');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !radacina.hidden) inchide();
  });

  /* ---------- declanșatorul ---------- */

  function poateAparea() {
    try {
      if (sessionStorage.getItem('hf-up-refuzat')) return false;
    } catch (e) { /* mod privat */ }
    /* Cine are deja 9 frecvențe nu mai are ce upgrade să facă. */
    return inCos.length < 9;
  }

  function laAdaugare(date) {
    if (!date || date.source !== 'product-form') return;
    if (idFrecvente.indexOf(Number(date.productVariantId)) === -1) return;
    ultimaAdaugata = Number(date.productVariantId);

    citesteCos().then(function () {
      if (poateAparea()) setTimeout(deschide, 400);
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, laAdaugare);
  }

  citesteCos();
})();
